import React, { useEffect, useState } from "react";
import {
  Stack,
  Typography,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Navigate, useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  startOverAPICall,
  segmentDetailsAPICall,
  segmentDetailsPostAPICall,
  stageDetailsAPICall,
} from "../shared copy/APICalls";
import routesData from "../shared copy/routes.json";
import TradingStyles from "../pages copy/Styles/TradingPreference.module.scss";
import BackButtonListener from "../Components copy/PreventBackNavigation/PreventBackNavigation";
import StageLayout from "../Layouts/StageLayout";
import icon from "../Components copy/assets/Images/iconnew.svg";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import TickCircle from "../Components copy/assets/Images/tick-circle.svg";
import EmptyCircle from "../Components copy/assets/Images/TickEmptyCircle.svg";
import BackDrop from "../Components copy/BackDrop";
import StartOverBackDrop from "../Components copy/StartOverBackDrop";
import ErrorSnackBar from "../Components copy/SnackBars/ErrorSnackBar";

const TradingPreferenceSchema = Yup.object().shape({
  Equity: Yup.boolean().oneOf([true], "Equity is required"),
});

export default function TradingPreference() {
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [segmentData, setSegmentData] = useState<any>([]);
  const [completedStages, setCompletedStages] = useState<any>();
  const [prefilloading, setprefilloading] = useState(true);
  const [backdrop, setBackDrop] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");

  const [prefillData, setprefillData] = useState<any>({
    equity: true,
    futures_and_options: true,
    currency: false,
    commodity: true,
    mutual_funds: true,
  });

  const navigationData:any = routesData;

  useEffect(() => {
    window.scrollTo(0, 0);
    segmentDetailsAPICall()
      .then((response: any) => {
        const responseData = response.data.data;
        console.log("responseData", responseData);
        setSegmentData(responseData.filter((a:any)=> a.segmentLink !== "currency"));
      })
      .catch((error: any) => {});

    let obj: any = {
      stage: "segment_details",
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        setCompletedStages(responseData.completed_stages);
        setprefilloading(false);

        // console.log("response", response.data.data.StageDetails);
        //  console.log("response", response.data.data.StageDetails.map((data: any) =>  data.IsOpted));
        setprefillData((prev:any) => {
          return {
            ...prev,
            equity: responseData.data.StageDetails.EquityOpted,
            futures_and_options:
              responseData.data.StageDetails.Futures_and_optionsOpted,
            currency: responseData.data.StageDetails.CurrencyOpted,
            commodity: responseData.data.StageDetails.CommodityOpted,
            mutual_funds: responseData.data.StageDetails.Mutual_fundsOpted,
          };
        });
        if (response.data.data.StageDetails.ErrorMessage) {
          setRejectMessage(response.data.data.StageDetails.ErrorMessage);
        }
      })
      .catch((error: any) => {
        setprefilloading(false);
        // console.log("error", error);
      });
  }, []);

  function segmentDetailsPost(data: any) {
 
    setloading(true);
    // console.log("dataIndex", data[0].segmentId);
    // let obj = {
    //   segment_details: [
    //     {
    //       SegmentLink: data[0].segmentLink,
    //       IsOpted: true,
    //     },
    //     {
    //       SegmentLink: data[1].segmentLink,
    //       IsOpted: true,
    //     },
    //     {
    //       SegmentLink: data[2].segmentLink,
    //       IsOpted: true,
    //     },
    //     {
    //       SegmentLink: data[3].segmentLink,
    //       IsOpted: true,
    //     },
    //     {
    //       SegmentLink: data[4].segmentLink,
    //       IsOpted: true,
    //     },
    //   ],
    // };
    console.log("data", data)
    let obj = {
      segment_details: [
        {
          SegmentLink: data[0].segmentLink,
          IsOpted: data[0].isOpted,
        },
        {
          SegmentLink: data[1].segmentLink,
          IsOpted: data[1].isOpted,
        },
        {
          SegmentLink: data[2].segmentLink,
          IsOpted: data[2].isOpted,
        },
        {
          SegmentLink: data[3].segmentLink,
          IsOpted: data[3].isOpted,
        },
        {
          SegmentLink: "currency",
          IsOpted: false,
        },
      ],
    };
  
    segmentDetailsPostAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        // console.log("responseData", responseData);
        setloading(false);
        if (
          responseData.data.stage &&
          navigationData.hasOwnProperty(responseData.data.stage)
        ) {
          navigate(navigationData[responseData.data.stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);
      });
  }

  const handleClick = () => {
    navigate("/yourprofile");
  };
  //console.log(prefillData.mutual_funds);

  const handleStartOver = () => {
    if (window.confirm("Are you sure you want to restart, on pressing Yes all the Data will be deleted")) {
      setBackDrop(true);
      startOverAPICall()
        .then((response: any) => {
          const responseData = response.data;
          // console.log("responseData", response);
          setBackDrop(false);
          navigate("/mobile");
          window.location.reload();
        })
        .catch((error: any) => {
          setBackDrop(false);
        });
    }
  };

  const InitialValues = {
    equity: true,
    futures_and_options: prefillData.futures_and_options,
    // currency: !prefillData.currency,
    commodity: prefillData.commodity,
    mutual_funds: prefillData.mutual_funds,
  };

  //console.log(selectedCheckboxes);

  const handleCheckBoxClick = (name: any, callback: any, values: any) => {
    callback(name, !values[name]);
  };

  return (
    <>
      <StageLayout
        completedStages={completedStages}
        stageName={"Trading Preferences"}
        navigatePath={"/yourprofile"}
      />
      <ErrorSnackBar message={rejectMessage} />
      <div className={TradingStyles.wrapper}>
        {!prefilloading ? (
          <Formik
            initialValues={InitialValues}
            validationSchema={TradingPreferenceSchema}
            onSubmit={(values:any) => {
              console.log("vlaue", values)
              const selectedSegments = segmentData
                .filter((segment: any) => values[segment.segmentLink])
                .map((segment: any) => ({
                  segmentName: segment.segmentName,

                  segmentLink: segment.segmentLink,
                }));

              const updatedSegmentData = segmentData.map((a: any) => {
                const isOpted = selectedSegments.some(
                  (b: any) => b.segmentLink === a.segmentLink
                );
                return { ...a, isOpted };
              });
              segmentDetailsPost(updatedSegmentData);
              // console.log(updatedSegmentData);

              // navigate("/yourprofile");
            }}
          >
            {({ errors, touched, handleSubmit, setFieldValue, values }) => {
              console.log("values", values);
              return (
                <Form
                  onKeyDown={(event) => {
                    event.code === "Enter" ||
                      (event.code === "NumpadEnter" && handleSubmit());
                  }}
                >
                  <Stack alignItems={"center"}>
                    <div className={TradingStyles.headerSection}>
                      <p className={TradingStyles.signup}>
                        Choose Your Trading Preference
                      </p>
                    </div>
                    <Stack marginTop={"30px"}>
                      <div
                        className={TradingStyles.checkBoxFeild}
                        style={{
                          background: "#ECFDF3",
                        }}
                      >
                        <FormControlLabel
                          sx={{ marginRight: "10px", width: "100%" }}
                          control={
                            <Checkbox
                              icon={<img src={TickCircle} width={"24px"} />}
                              checkedIcon={
                                <img src={TickCircle} width={"24px"} />
                              }
                              name={"equity"}
                              //disabled={segment.segmentLink === "equity"}
                              style={{ height: "20px", width: "20px" }}
                              checked
                            />
                          }
                          label={"Equity"}
                        />

                        <span className={TradingStyles.defaultLabel}>
                          Default
                        </span>
                      </div>
                      {/* <div
                        className={TradingStyles.checkBoxFeild}
                        style={{
                          background: "#ECFDF3",
                        }}
                      >
                        <FormControlLabel
                          sx={{ marginRight: "10px", width: "100%" }}
                          control={
                            <Checkbox
                              icon={<img src={TickCircle} width={"24px"} />}
                              checkedIcon={
                                <img src={TickCircle} width={"24px"} />
                              }
                              name={"futures_and_options"}
                              //disabled={segment.segmentLink === "equity"}
                              style={{ height: "20px", width: "20px" }}
                              checked
                            />
                          }
                          label={"F & O"}
                        />
                      </div> */}
                      {/* <div
                        className={TradingStyles.checkBoxFeild}
                        style={{
                          background: "#ECFDF3",
                        }}
                      >
                        <FormControlLabel
                          sx={{ marginRight: "10px", width: "100%" }}
                          control={
                            <Checkbox
                              icon={<img src={TickCircle} width={"24px"} />}
                              checkedIcon={
                                <img src={TickCircle} width={"24px"} />
                              }
                              name={"currency"}
                              //disabled={segment.segmentLink === "equity"}
                              style={{ height: "20px", width: "20px" }}
                              checked
                            />
                          }
                          label={"Currency"}
                        />
                      </div> */}
                      {/* <div
                        className={TradingStyles.checkBoxFeild}
                        style={{
                          background: "#ECFDF3",
                        }}
                      >
                        <FormControlLabel
                          sx={{ marginRight: "10px", width: "100%" }}
                          control={
                            <Checkbox
                              icon={<img src={TickCircle} width={"24px"} />}
                              checkedIcon={
                                <img src={TickCircle} width={"24px"} />
                              }
                              name={"commidity"}
                              //disabled={segment.segmentLink === "equity"}
                              style={{ height: "20px", width: "20px" }}
                              checked
                            />
                          }
                          label={"Commidity"}
                        />
                      </div> */}
                      {/* <div
                        className={TradingStyles.checkBoxFeild}
                        style={{
                          background: "#ECFDF3",
                        }}
                      >
                        <FormControlLabel
                          sx={{ marginRight: "10px", width: "100%" }}
                          control={
                            <Checkbox
                              icon={<img src={TickCircle} width={"24px"} />}
                              checkedIcon={
                                <img src={TickCircle} width={"24px"} />
                              }
                              name={"mutualfunds"}
                              //disabled={segment.segmentLink === "equity"}
                              style={{ height: "20px", width: "20px" }}
                              checked
                            />
                          }
                          label={"Mutual Funds"}
                        />
                      </div> */}

                      <FormGroup
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                      >
                        {[
                          ...segmentData.filter(
                            (segment:any) =>
                              segment.segmentLink === "futures_and_options"
                          ),
                          ...segmentData.filter(
                            (segment:any) =>
                              segment.segmentLink !== "equity" &&
                              segment.segmentLink !== "futures_and_options"
                          ),
                        ].map((segment: any, index: any) => (
                          <div
                            className={TradingStyles.checkBoxFeild}
                            style={{
                              background: values[segment.segmentLink]
                                ? "#ECFDF3"
                                : "white",
                            }}
                            key={segment.segmentLink}
                          >
                            <FormControlLabel
                              sx={{ marginRight: "10px", width: "100%" }}
                              control={
                                <Checkbox
                                  icon={
                                    values[segment.segmentLink] === true ? (
                                      <img src={TickCircle} width={"24px"} />
                                    ) : (
                                      <img src={EmptyCircle} width={"24px"} />
                                    )
                                  }
                                  checkedIcon={
                                    values[segment.segmentLink] === "equity" ? (
                                      <img src={EmptyCircle} width={"24px"} />
                                    ) : (
                                      <img src={TickCircle} width={"24px"} />
                                    )
                                  }
                                  name={segment.segmentLink}
                                  onClick={(e) => {
                                    if (segment.segmentLink !== "equity") {
                                      e.stopPropagation();
                                      handleCheckBoxClick(
                                        segment.segmentLink,
                                        setFieldValue,
                                        values
                                      );
                                    }
                                  }}
                                  //disabled={segment.segmentLink === "equity"}
                                  style={{ height: "20px", width: "20px" }}
                                  value={values[segment.segmentLink]}
                                  checked={values[segment.segmentLink]}
                                />
                              }
                              label={segment.segmentName}
                            />
                            {segment.segmentLink === "equity" && (
                              <span className={TradingStyles.defaultLabel}>
                                Default
                              </span>
                            )}
                          </div>
                        ))}
                      </FormGroup>
                    </Stack>
                    {backdrop && <StartOverBackDrop />}
                    <div className={TradingStyles.buttonStack}>
                      <div>
                        <LoadingButton
                          id="tradingPreferencesContinueButton"
                          variant="contained"
                          // type="submit"
                          onClick={() => {
                            handleSubmit();
                          }}
                          className={TradingStyles.approveButton}
                        >
                          Continue
                        </LoadingButton>
                      </div>
                      <div className={TradingStyles.startOverSection}>
                        <img src={icon} className={TradingStyles.iconImage} />
                        <p className={TradingStyles.paratext}>
                          {" "}
                          if the above mentioned info not yours
                          <span
                            className={TradingStyles.startoverbutton}
                            onClick={handleStartOver}
                          >
                            Start Over
                          </span>
                        </p>
                      </div>
                    </div>
                  </Stack>
                </Form>
              );
            }}
          </Formik>
        ) : (
          // <Stack alignItems={"center"}>
          //   <div className={TradingStyles.headerSection}>
          //     <p className={TradingStyles.signup}>
          //       Choose Your Trading Preference
          //     </p>
          //   </div>
          //   <Stack marginTop={"30px"}>
          //     <FormGroup
          //       style={{
          //         display: "flex",
          //         flexDirection: "column",
          //         justifyContent: "center",
          //       }}
          //     >
          //       <div
          //         className={TradingStyles.checkBoxFeild}
          //         style={{
          //           background: "#ECFDF3",
          //         }}
          //       >
          //         <FormControlLabel
          //           control={
          //             <Checkbox
          //               name="equity"
          //               disabled
          //               checked
          //               size="small"
          //               sx={{ padding: "0 !important" }}
          //             />
          //           }
          //           label="Equity"
          //           sx={{ margin: "0 !important" }}
          //         />
          //       </div>
          //       <div className={TradingStyles.checkBoxFeild}>
          //         <FormControlLabel
          //           control={
          //             <Checkbox
          //               name="equity "
          //               size="small"
          //               sx={{ padding: "0 !important" }}
          //             />
          //           }
          //           label="Commodity"
          //           sx={{ margin: "0 !important" }}
          //         />
          //       </div>
          //       <div className={TradingStyles.checkBoxFeild}>
          //         <FormControlLabel
          //           control={
          //             <Checkbox
          //               name="equity"
          //               size="small"
          //               sx={{ padding: "0 !important" }}
          //             />
          //           }
          //           label="Currency"
          //           sx={{ margin: "0 !important" }}
          //         />
          //       </div>
          //       <div className={TradingStyles.checkBoxFeild}>
          //         <FormControlLabel
          //           control={
          //             <Checkbox
          //               name="equity"
          //               size="small"
          //               sx={{ padding: "0 !important" }}
          //             />
          //           }
          //           label="f&O"
          //           sx={{ margin: "0 !important" }}
          //         />
          //       </div>
          //       <div className={TradingStyles.buttonStack}>
          //         <div>
          //           <LoadingButton
          //             id="tradingPreferencesContinueButton"
          //             variant="contained"
          //             type="submit"
          //             className={TradingStyles.approveButton}
          //           >
          //             Continue
          //           </LoadingButton>
          //         </div>
          //         <div className={TradingStyles.startOverSection}>
          //           <img src={icon} className={TradingStyles.iconImage} />
          //           <p className={TradingStyles.paratext}>
          //             {" "}
          //             if the above mentioned info not your
          //             <span
          //               className={TradingStyles.startoverbutton}
          //               onClick={handleStartOver}
          //             >
          //               Start Over
          //             </span>
          //           </p>
          //         </div>
          //       </div>
          //     </FormGroup>
          //   </Stack>
          // </Stack>
          <div className={TradingStyles.wrapper}>
            <BackDrop />
          </div>
        )}
      </div>
    </>
  );
}
